<template>
	<div
		id="mouseover"
		@mouseenter="actions.setConstrain"
		@mousemove="actions.onMouseMove"
		@mouseleave="actions.resetConstrain">
		<!-- Disable class sticker-shadow for Mobile Only -->
		<div
			class="reward-sticker pointer mt-0"
			:class="!isMobile && 'reward-sticker-shadow'"
			:id="'sticker-card' + id"
			@click="actions.onStickerClick()">
			<img
				v-if="sticker.reward.unlocked"
				class="check-icon"
				width="40"
				src="@/assets/icons/check.png"
				alt="Check" />
			<v-row no-gutters align="center">
				<v-col :cols="4" :class="size === 'md' && 'pl-1'">
					<div class="d-flex align-center justify-center">
						<img src="@/assets/icons/icon_reward.png" class="reward-icon mt-1" alt="Reward" />
						<v-img
							:src="getStickerImagePath(sticker)"
							class="sticker-image"
							width="auto"
							contain
							max-height="57">
						</v-img>
					</div>
				</v-col>
				<v-col :cols="8" class="pr-2" :class="size === 'md' && 'pl-2'">
					<h4 class="sticker-title white--text fs--12">{{ sticker.name }}</h4>
					<div class="progress-bar">
						<v-progress-linear
							class="sticker-progress"
							:height="8"
							color="progress"
							background-color="progressBg"
							rounded
							:value="sticker.reward.pctComplete * 100"
							:min="0"
							:max="100">
						</v-progress-linear>
					</div>
					<div class="sticker-subtitle d-flex flex-column mt-2">
						<span class="fs--11 fw--600 white--text"
							>{{ sticker.reward.viewerEarnedInSlot.toLocaleString() }} /
							{{ sticker.reward.bitsRequired.toLocaleString() }} Bits</span
						>
					</div>
				</v-col>
			</v-row>
			<div class="reward-sticker-footer d-flex align-center justify-center">
				<template v-if="sticker.reward.unlocked">
					<strong class="fs--11 fw--600 unlocked-text white--text pt-1"
						>Complete! This sticker has been unlocked!</strong
					>
				</template>
				<template v-else>
					<img :src="actions.getIcon(sticker.reward.bitsToUnlock)" width="15" class="mr-1" alt="Bits" />
					<strong class="white--text fs--12 fw--600"
						>Use {{ sticker.reward.bitsToUnlock.toLocaleString() }} Bits on stickers to unlock!</strong
					>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { useStore } from '@/store';
import { getBitIcon, getStickerImagePath } from '@/utils/utils';

export default {
	name: 'StickerReward',
	props: {
		id: String,
		sticker: Object,
	},
	emits: ['onStickerClick'],
	setup(props, ctx) {
		const hover = ref(false);
		const constrain = ref(0);

		const store = useStore();

		const speed = computed(() => store.state.speed);
		const size = computed(() => store.state.size);

		const isMobile = computed(() => {
			return store.state.isMobile;
		});

		watch(
			() => speed,
			function (val) {
				constrain.value = val;
			},
		);

		const actions = {
			onStickerClick() {
				if (props.sticker.reward.unlocked) {
					ctx.emit('onStickerClick', props.sticker);
				}
			},
			getIcon(value) {
				return getBitIcon(value);
			},
			setConstrain() {
				hover.value = true;
				constrain.value = 20;
			},
			resetConstrain() {
				hover.value = false;
				constrain.value = 0;

				let card = document.getElementById('sticker-card' + props.id);
				let xy = [0, 0];
				let position = xy.concat([card]);

				window.requestAnimationFrame(() => actions.transformElement(card, position));
			},
			transforms(x, y, el) {
				let box = el.getBoundingClientRect();
				let calcX = -(y - box.y - box.height / 2) / constrain.value;
				let calcY = (x - box.x - box.width / 2) / constrain.value;

				if (hover.value) {
					return (
						'perspective(100px) ' +
						'   rotateX(' +
						calcX +
						'deg) ' +
						'   rotateY(' +
						calcY +
						'deg) ' +
						'   scale(1.10) '
					);
				}

				return (
					'perspective(100px) ' + '   rotateX(' + 0 + 'deg) ' + '   rotateY(' + 0 + 'deg) ' + '   scale(1) '
				);
			},
			transformElement: function (el, xyEl) {
				el.style.transform = this.transforms.apply(null, xyEl);
				el.style.transition = '0.25s ease-out';
			},

			onMouseMove(e) {
				if (!isMobile.value) {
					hover.value = true;
					let card = document.getElementById('sticker-card' + props.id);
					let xy = [e.clientX, e.clientY];
					let position = xy.concat([card]);

					window.requestAnimationFrame(() => actions.transformElement(card, position));
				}
			},
		};

		return {
			isMobile,
			hover,
			constrain,
			size,
			speed,
			actions,
			getStickerImagePath,
		};
	},
};
</script>

<style lang="scss"></style>
